import React from 'react'
import parse from 'html-react-parser'
import PropTypes from 'prop-types'
import AdditionalNote from './AdditionalNote'
import UpdatedOn from './UpdatedOn'
import { stripEmptyParagraphTags } from 'src/core/utils'
import { createSlug } from 'src/core/urls'
import FeedbackFormLink from './FeedbackFormLink'

const propTypes = {
  faq: PropTypes.array,
  links: PropTypes.string,
}

const FAQ = props => {
  const { faq, index, links } = props
  return (
    <article
      className="my-24 anchor"
      id={index !== null ? `${createSlug(faq.QuestionText)}` : ''}
    >
      <div className="mb-3">
        <h2 className="text-2xl font-semibold">{faq.QuestionText}</h2>
      </div>
      {faq.AnswerText && (
        <div className="text-lg leading-normal markdown">
          {parse(stripEmptyParagraphTags(faq.AnswerText))}
        </div>
      )}
      {faq.AdditionalNote && <AdditionalNote copy={faq.AdditionalNote} />}
      <UpdatedOn date={faq.ChangeDate} />
      <FeedbackFormLink
        formCategory={links}
        urlForm={faq.FAQ_CTAs[0]?.TargetPath}
        formTitle={faq.FAQ_CTAs[0]?.LinkCaption}
        formType={faq.FAQ_CTAs[0]?.LinkCopy}
      />
    </article>
  )
}

FAQ.propTypes = propTypes

export default FAQ
